document.addEventListener( 'DOMContentLoaded', () => {
    
    let page = 1
    const loadMoreButton = document.querySelector('.events-component__footer .load-more')
    const postsGrid = document.querySelector('.events-component__grid')

    if( loadMoreButton != undefined ) {

        loadMoreButton.addEventListener( 'click', (e) => {

            e.preventDefault()

            loadMoreButton.textContent = params.loading_text

            const formData = new FormData()
            formData.append( 'action', 'load_events' )
            formData.append( 'page', page );
            formData.append('posts_per_page', params.posts_per_page );

            let xhr = new XMLHttpRequest();
            xhr.open('POST', params.ajaxurl, true);

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 400) {

                    const response = JSON.parse(xhr.responseText)
                    postsGrid.innerHTML += response.html
                    loadMoreButton.textContent = params.load_more_text
                    page++

                    if (response.no_more_posts) {
                        loadMoreButton.style.display = 'none';
                    }

                } else {
                    console.log( 'Error: ', xhr.status )
                }
            }

            xhr.onerror = () => {
                console.log( 'Request failed' )
            }

            xhr.send( formData )

        })
    }

})